export const selectCommentsSummaryById = (state) =>
  state.CommentsSummary.get('byId');
